export const validationDocumentationSagaActionTypes = {
  callGetValidationDocumentationSaga: "callGetValidationDocumentationSaga",
  callSaveValidationDocumentationSaga: "callSaveValidationDocumentationSaga",
  callSubmitValidationDocumentationSaga: "callSubmitValidationDocumentationSaga",
  callFinalSubmitValidationDocumentationSaga: "callFinalSubmitValidationDocumentationSaga",
  callGetValidationHistorySaga: "callGetValidationHistorySaga",
  callGetValidationHistoryDetailSaga: "callGetValidationHistoryDetailSaga",
  callGetValidationSummarySaga: "callGetValidationSummarySaga",
  callGetRecentHistoryDocumentationSaga: "callGetRecentHistoryDocumentationSaga",
  callExportHistoryValidationReportSaga: "callExportHistoryValidationReportSaga",
  callDownloadSolutionCertificateSaga: "callDownloadSolutionCertificateSaga",
};

export type GetValidationDocumentationPayloadType = {
  technology: string;
  integrationType: string;
  integrationId: number;
};

export type RequirementSaveType = {
  requirement_id: number;
  implementation_status?: string;
  verification_status?: string;
  partner_comments?: string;
  hid_comments?: string;
};

export type CategorySaveType = {
  category_id: number;
  requirements: RequirementSaveType[];
};

export type SaveValidationDocumentationPayloadType = {
  technology: string;
  integration_type: string;
  integration_id: number;
  user: number;
  partner_notes?: string;
  hid_notes?: string;
  validation_status?: string;
  categories: CategorySaveType[];
  isHistoryView?: boolean;
  /** TEMPORARY: Data-entry block "Submitted on" date (YYYY-MM-DD). Remove with TEMPORARY block. */
  created_at?: string;
};

export const getValidationDocumentationSagaAction: (
  technology: string,
  integrationType: string,
  integrationId: number
) => {
  type: string;
  payload: GetValidationDocumentationPayloadType;
} = (technology: string, integrationType: string, integrationId: number) => {
  return {
    type: validationDocumentationSagaActionTypes.callGetValidationDocumentationSaga,
    payload: {
      technology,
      integrationType,
      integrationId,
    },
  };
};

export const saveValidationDocumentationSagaAction: (
  payload: SaveValidationDocumentationPayloadType
) => {
  type: string;
  payload: SaveValidationDocumentationPayloadType;
} = (payload: SaveValidationDocumentationPayloadType) => {
  return {
    type: validationDocumentationSagaActionTypes.callSaveValidationDocumentationSaga,
    payload,
  };
};

export type SubmitValidationDocumentationPayloadType = {
  integration_id: number;
  user: number;
  savePayload: SaveValidationDocumentationPayloadType;
  /** TEMPORARY: Data-entry block "Submitted on" date (YYYY-MM-DD). Remove with TEMPORARY block. */
  created_at?: string;
};

export const submitValidationDocumentationSagaAction: (
  payload: SubmitValidationDocumentationPayloadType
) => {
  type: string;
  payload: SubmitValidationDocumentationPayloadType;
} = (payload: SubmitValidationDocumentationPayloadType) => {
  return {
    type: validationDocumentationSagaActionTypes.callSubmitValidationDocumentationSaga,
    payload,
  };
};

export type GetValidationHistoryPayloadType = {
  integration_id: number;
};

export const getValidationHistorySagaAction: (
  integrationId: number
) => {
  type: string;
  payload: GetValidationHistoryPayloadType;
} = (integrationId: number) => {
  return {
    type: validationDocumentationSagaActionTypes.callGetValidationHistorySaga,
    payload: {
      integration_id: integrationId,
    },
  };
};

export type GetValidationHistoryDetailPayloadType = {
  integration_id: number;
  documentation_id: number;
};

export const getValidationHistoryDetailSagaAction: (
  integrationId: number,
  documentationId: number
) => {
  type: string;
  payload: GetValidationHistoryDetailPayloadType;
} = (integrationId: number, documentationId: number) => {
  return {
    type: validationDocumentationSagaActionTypes.callGetValidationHistoryDetailSaga,
    payload: {
      integration_id: integrationId,
      documentation_id: documentationId,
    },
  };
};


export type FinalSubmitValidationDocumentationPayloadType = {
  integration_id: number;
  user: number;
  documentation_id: number;
  savePayload: SaveValidationDocumentationPayloadType;
  created_at?: string;
};

export const finalSubmitValidationDocumentationSagaAction: (
  payload: FinalSubmitValidationDocumentationPayloadType
) => {
  type: string;
  payload: FinalSubmitValidationDocumentationPayloadType;
} = (payload: FinalSubmitValidationDocumentationPayloadType) => {
  return {
    type: validationDocumentationSagaActionTypes.callFinalSubmitValidationDocumentationSaga,
    payload,
  };
};

export type GetValidationSummaryPayloadType = {
  integration_id: number;
  documentation_id: number;
};

export const getValidationSummarySagaAction: (
  integrationId: number,
  documentationId: number
) => {
  type: string;
  payload: GetValidationSummaryPayloadType;
} = (integrationId: number, documentationId: number) => {
  return {
    type: validationDocumentationSagaActionTypes.callGetValidationSummarySaga,
    payload: {
      integration_id: integrationId,
      documentation_id: documentationId,
    },
  };
};

export type GetRecentHistoryDocumentationPayloadType = {
  integration_id: number;
  documentation_id: number;
};

export const getRecentHistoryDocumentationSagaAction: (
  integrationId: number,
  documentationId: number
) => {
  type: string;
  payload: GetRecentHistoryDocumentationPayloadType;
} = (integrationId: number, documentationId: number) => {
  return {
    type: validationDocumentationSagaActionTypes.callGetRecentHistoryDocumentationSaga,
    payload: {
      integration_id: integrationId,
      documentation_id: documentationId,
    },
  };
};

export type ExportHistoryValidationReportPayloadType = {
  integration_id: number;
  documentation_id: number;
  partner_name?: string;
  project_name?: string;
};

export const exportHistoryValidationReportSagaAction: (
  payload: ExportHistoryValidationReportPayloadType
) => {
  type: string;
  payload: ExportHistoryValidationReportPayloadType;
} = (payload: ExportHistoryValidationReportPayloadType) => ({
  type: validationDocumentationSagaActionTypes.callExportHistoryValidationReportSaga,
  payload,
});

export type DownloadSolutionCertificatePayloadType = {
  integration_id: number;
  documentation_id: number;
  /** Not returned by the certificate API; taken from the partner details in the store. */
  company_name: string;
};

export const downloadSolutionCertificateSagaAction: (
  payload: DownloadSolutionCertificatePayloadType
) => {
  type: string;
  payload: DownloadSolutionCertificatePayloadType;
} = (payload: DownloadSolutionCertificatePayloadType) => ({
  type: validationDocumentationSagaActionTypes.callDownloadSolutionCertificateSaga,
  payload,
});